import React from "react";
import {CLIENT_COMPANY_TYPE, CLIENT_PERSON_TYPE} from "./client";

export default function getClientName(client){
  let name = [];

  switch (client.type) {
    case CLIENT_PERSON_TYPE: {
      client.firstname && name.push(client.firstname);
      client.lastname && name.push(client.lastname);
      break;
    }
    case CLIENT_COMPANY_TYPE: {
      name.push(client.name);
      break;
    }
    default: {
      return <i>Brak danych dla tego typu klienta</i>;
    }
  }

  if(name.length === 0){
    name.push('Brak danych')
  }

  return name.join(' ')
}
